import React from "react";
import { Modal, Row, Col, Spinner } from "react-bootstrap";
import styled from "styled-components";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { getBuyHistory } from "network/apis/StoreApi";
import { PersianDate } from "helpers/dates";
import CommonTable from 'components/CommonTable';
import {
	IN_STOCK,
	OUT_OF_STOCK,
} from "network/apis/CommonApi";

const ModalHolder = styled(Modal)`
  font-family: "YEKAN-BAKH-MEDIUM";

  div.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 11rem;
    color: #3876e5;
  }
`;

const Header = styled.div`
  font-size: 18pt;
  width: 100%;
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;

  div.loading {
    min-height: 11rem;
  }
`;

const EmptyList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 7rem;
  text-align: center;
  color: #616161;
  font-size: 14pt;
`;

const CloseButton = styled.div`
  background-color: #424250;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  top: 12px;
  right: 10px;
`;

const cols = ['تاریخ', 'محل نگهداری', 'واحد', 'مقدار', 'نوع'];

const BuyHistoryModal = ({
    isOpen,
    onClose,
    data,
    parentType,
    ...rest
}) => {
    const { data: history, isLoading } = useQuery(
        ["get-buy-history", data?.input_id ? `${data.input_id}` : 'concentrate'],
        () => getBuyHistory(data?.input_id ?? null, parentType !== 'admin'),
        {
            refetchOnWindowFocus: false,
        }
    );

    const getTypeLabel = (item) => {
        switch (item?.type ?? '') {
            case 'produce':
                return 'تولید';
                break;
            case 'purchase':
                return 'خرید';
                break;
            case 'distribute':
                return 'توزیع';
                break;
            default:
                return '-';
        }
    };

    const getStorageLocationLabel = (id) => {
        if (id === IN_STOCK) return 'موجود در انبار';
        if (id === OUT_OF_STOCK) return 'سایر';

        return '-';
    };

    const getList = () => history?.data?.items ?? [];
    const isListEmpty = () => getList().length < 1;

    return (
        <ModalHolder
            show={isOpen}
            size={"lg"}
            centered
            animation={false}
            onHide={onClose}
            {...rest}
        >
            <Modal.Body className="px-5">
                <CloseButton onClick={onClose}>
                    <MdClose color="#fff" />
                </CloseButton>
                <Header>
                    <span>{data?.name?.name ?? 'نام نهاده'}</span>
                </Header>
                {isLoading ? (
                    <div className="loading">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : (
                    isListEmpty() ? (
                        <EmptyList>در حال حاضر رکوردی ثبت نشده است</EmptyList>
                    ) : (
                        <div>
                            <CommonTable cols={cols}>
                                {getList().map((item, index) => (
                                    <tr key={index}>
                                        <td>{new PersianDate(item?.created_at).getParts().join('/')}</td>
                                        <td>{getStorageLocationLabel(item.storage_location)}</td>
                                        <td>{item?.unit?.name ?? '-'}</td>
                                        <td>{`${item?.amount ?? 0}`.persianCurrency()}</td>                                        
                                        <td>{getTypeLabel(item)}</td>
                                    </tr>
                                ))}
                            </CommonTable>
                        </div>
                    )
                )}
            </Modal.Body>
        </ModalHolder>
    );
};

export default BuyHistoryModal;
